import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Reusable admin image uploader. onUploaded receives {url, alt}.
export function ImageUpload({ onUploaded, label = "Upload image", testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded({ url: data.url, alt: "" });
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <label
      data-testid={testid}
      className="flex cursor-pointer items-center gap-2 rounded border border-dashed border-kys-blush-border bg-kys-blush px-4 py-3 text-sm font-medium text-kys-charcoal transition hover:border-kys-accent hover:bg-kys-blush-soft"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UploadCloud className="h-4 w-4" />}
      {busy ? "Uploading…" : label}
      <input type="file" accept="image/*" className="hidden" onChange={handle} disabled={busy} />
    </label>
  );
}
